module.exports = __webpack_public_path__ + "static/media/SEVEN.b3f4b923.png";